import { createAction, props } from '@ngrx/store';
import {
  SeatMap,
  ReserveSeatConfirmation,
  ReserveSeatRequestService,
  ICancelSeatRequestService,
  ICancelSeatResponseBody,
  ReservationSeat
} from 'src/app/core/models/seat.model';

export const ReserveSeat = createAction(
  '[Seat] Save selected seat',
  props<{ reserveSeatRequestService: ReserveSeatRequestService }>()
);

export const ReserveSeatSuccess = createAction(
  '[Seat] Save selected seat success',
  props<{ reserveSeatResult: ReserveSeatConfirmation }>()
);

export const ReserveSeatFailed = createAction(
  '[Seat] Save selected seat failed',
  props<{ error: string }>()
);

export const CancelSeat = createAction(
  '[Seat] Cancel selected seat',
  props<{ gds: string; cancelSeatRequestService: ICancelSeatRequestService }>()
);

export const CancelSeatSuccess = createAction(
  '[Seat] Cancel selected seat success',
  props<{ cancelSeatResult: ICancelSeatResponseBody }>()
);

export const CancelSeatFailed = createAction(
  '[Seat] Cancel selected seat failed',
  props<{ error: string }>()
);

export const showSeatMap = createAction('[SeatMap] Show seat map');

export const hideSeatMap = createAction('[SeatMap] Hide seat map');

export const GetSeatMapSuccess = createAction(
  '[SeatMap] Get seat map success',
  props<{ seatMap: SeatMap }>()
);

export const GetSeatMapFailed = createAction(
  '[SeatMap] Get seat map failed',
  props<{ error: string }>()
);

export const SaveSeatSelection = createAction(
  '[Involuntary Change Page] Save Seats Map Selected',
  props<{ seatListToReserve: ReservationSeat }>()
);

export const RemoveSeatSelection = createAction(
  '[Involuntary Change Page] Remove Seat Map Selected',
  props<{ seatNumber: string; seatName: string; segment: string }>()
);
